// extracted by mini-css-extract-plugin
export default {"dot":"my-page-loader-module--dot--3221a","circleContainer":"my-page-loader-module--circle-container--02ba1"};